import type { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  width?: 'content' | 'wide';
  className?: string;
  as?: 'div' | 'section' | 'header' | 'footer' | 'main';
}

const widthMap = {
  content: 'max-w-content',
  wide: 'max-w-wide',
} as const;

export function Container({
  children,
  width = 'content',
  className = '',
  as: Tag = 'div',
}: ContainerProps): JSX.Element {
  return (
    <Tag className={`mx-auto w-full px-6 md:px-8 ${widthMap[width]} ${className}`.trim()}>
      {children}
    </Tag>
  );
}
